export default axios => ({
  redirect() {
    return axios.get('adfs/redirect')
  },

  getRedirectURL() {
    return axios.get('adfs/redirect-url')
  }
})